import React, { useContext } from 'react';
import AuthContext from 'context/AuthContext';
import AzureMapBase from './AzureMapBase';
import AzureMapMarker from './AzureMapMarker';

const AzureMapAssetAndDevices = ({ asset, devices, height = "300px", show = false }) => {
    const { panel } = useContext(AuthContext);

    let center = panel?.coords || [0, 0];
    if (asset?.lat && asset?.lng) {
        center = [asset.lat, asset.lng];
    } else if (devices && devices.length > 0 && devices[0].lat && devices[0].lng) {
        center = [devices[0].lat, devices[0].lng];
    }

    return (
        <AzureMapBase
            center={center}
            zoom={15}
            height={height}
        >
            {asset && asset.lat && asset.lng && (
                <AzureMapMarker
                    position={[asset.lat, asset.lng]}
                    options={{
                        color: '#49cb5c'
                    }}
                />
            )}
            {devices && devices.map((device, index) => (
                <AzureMapMarker
                    key={index}
                    position={[device.lat, device.lng]}
                    options={{
                        color: '#1774fa'
                    }}
                />
            ))}
        </AzureMapBase>
    );
};

export default AzureMapAssetAndDevices;
